export default {
  setUsersData (state, data) {
    state.usersData = data;
  },
  setProfilePicture (state, data) {
    state.usersData[data.i].profilePicture = data.profilePicture;
  },
};